import { createFeatureSelector, createSelector } from '@ngrx/store';
import { listarEdicoesCalendarioState } from '../../reducers/Jornal/listar-edicoes-para-calendario.reducer';

export const selectlistarEdicoesCalendarioState = createFeatureSelector<listarEdicoesCalendarioState>('listarEdicoesCalendario');

export const selectDadoslistarEdicoesCalendario = createSelector(
  selectlistarEdicoesCalendarioState,
  (state: listarEdicoesCalendarioState) => state.response
);

export const selectErroslistarEdicoesCalendario = createSelector(
  selectlistarEdicoesCalendarioState,
  (state: listarEdicoesCalendarioState) => state.error
);
